export const FEEDBACK_PHRASES = {
  none: "Nothing is correct",
  oneWell: "One number is correct and well placed",
  oneWrong: "One number is correct but wrongly placed",
  twoWell: "Two numbers are correct and well placed",
  twoWrong: "Two numbers are correct but wrongly placed",
  oneWellOneWrong:
    "One number is correct and well placed, one number is correct but wrongly placed",
} as const;

export type FeedbackKey = keyof typeof FEEDBACK_PHRASES;

export interface Feedback {
  key: FeedbackKey;
  phrase: (typeof FEEDBACK_PHRASES)[FeedbackKey];
  wellPlaced: number;
  wronglyPlaced: number;
}

export interface Clue {
  guess: number[];
  feedback: Feedback;
}

export interface PuzzleDifficulty {
  label: "Easy" | "Medium" | "Hard";
  score: number;
  remainingAfterEachClue: number[];
}

export interface Puzzle {
  version: "v1" | "v2";
  date: string;
  puzzleNumber: number;
  seed: number;
  code: number[];
  clues: Clue[];
  difficulty: PuzzleDifficulty;
}

export interface PuzzleOptions {
  length: number;
  allowRepeatedDigits: boolean;
}